
import { Component, Input, OnInit, ViewChild, inject } from '@angular/core';
import { NgbActiveModal, NgbAlertModule, NgbCarousel, NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { catchError, switchMap } from 'rxjs/operators';
import { EMPTY, zip } from 'rxjs';
import { Loader, IDocumentFile, DocumentPreviewType, LoaderSpinnerComponent } from '@aston/foundation';
import { DocumentFileService } from 'apps/console/src/app/shared-module/services/document-file.service';
import { TranslateModule } from '@ngx-translate/core';

import { previewType } from '../../functions';

@Component({
	selector: 'document-files-viewer',
	templateUrl: './document-files-viewer.component.html',
	imports: [TranslateModule, NgbCarouselModule, NgbAlertModule, LoaderSpinnerComponent]
})
export class DocumentFilesViewerComponent<T extends IDocumentFile> implements OnInit {
	activeModal = inject(NgbActiveModal);
	protected documentFileService = inject(DocumentFileService);

	@ViewChild('ngb-carousel', { static: true }) carousel: NgbCarousel;
	@Input() title: string;
	@Input() item: T;
	@Input() singleItem: T;
	@Input() showCloseButton = true;

	files = [];
	loader = new Loader(true);
	previewType = previewType;
	documentPreviewType = DocumentPreviewType;

	ngOnInit() {
		if (this.singleItem) this.loadSingleDocumentFile();
		if (this.item) this.loadDocumentFiles();
	}

	loadSingleDocumentFile() {
		this.documentFileService.getLocalFileURL(this.singleItem).pipe(
			catchError(e => {
				this.loader.error(e);
				return EMPTY;
			})
		).subscribe(file => {
			this.files = [file];
			this.loader.success();
		});
	}

	loadDocumentFiles() {
		this.documentFileService.getFilesOfDocument(this.item).pipe(
			switchMap(files =>
				zip(...files.map(file => this.documentFileService.getLocalFileURL(file)))
			),
			catchError(e => {
				this.loader.error(e);
				return EMPTY;
			})
		).subscribe(files => {
			this.files = files;
			this.loader.success();
		});
	}

}
